import styled from 'styled-components'

import { Checkbox as CheckboxUI } from '@workboard/wobo-ui'

import HelpText from './help-text'

const Checkbox = styled(CheckboxUI)`
  & .MuiFormControlLabel-label {
    display: flex;
    align-items: center;
  }

  ${HelpText} {
    margin-left: 8px;
  }
`

export default Checkbox
